    import axiosAuth from '../../../shared/configs/axios-auth'

    const getDefaultState = () => {
        return {
            table: {},
        }
    }
    
    const state = getDefaultState()

    const getters = {
        table: state => {
            return state.table
        },
    }

    const mutations = {
        resetState (state) {
            Object.assign(state, getDefaultState())
        },
        table: (state, payload) => {
            state.table = payload
        },
    }

    const actions = {
       
        getTable: ({commit}, payload) =>{
            commit('updating', true)
            axiosAuth.get('/tables/'+ payload._id)
            .then(
                res => {
                    console.log(res)
                    commit('updating', false)
                    if(!res.data.message){
                        commit('table', res.data)
                    }
                }
              )
              .catch(
                error => {
                  console.log(error.response)
                  commit('updating', false)
                }
              )
        },

        blockTable: ({commit, dispatch}, payload) => {
           
            commit('updating', true)
            axiosAuth.patch('/tables/block-table/'+ payload._id, payload)
            .then(
                res => {
                    dispatch('getTable', {_id: payload._id})
                    commit('trash', res)
                    commit('updating', false)
                    // dispatch('getMenus')                
                }
              )
            .catch(
                error => {
                    console.log(error.response)
                    commit('updating', false)
                }
            ) 
        },

    }

    export default {
        state,
        getters,
        mutations,
        actions
    }